/**
 * @generated SignedSource<<b094e9c8f73d426b1bfd802b7cb9cedc>>
 * @relayHash a2d3f14c75bff45a93389f308989352d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 30f67e67f8759c6613467d94fc91512ebded25adce73f03c80e1e6fb4fc5a288

import type { ConcreteRequest } from 'relay-runtime';
export type LabelInput = {
  name: string;
  prefix: string;
};
export type useLabelsSelectPropsAddLabelsMutation$variables = {
  contentId: string;
  labels: ReadonlyArray<LabelInput>;
};
export type useLabelsSelectPropsAddLabelsMutation$data = {
  readonly addLabels: {
    readonly __typename: "AddLabelsPayload";
    readonly labels: {
      readonly __typename: "PaginatedLabelList";
      readonly count: number | null;
      readonly nodes: ReadonlyArray<{
        readonly __typename: "Label";
        readonly id: string | null;
        readonly label: string | null;
        readonly name: string | null;
        readonly prefix: string | null;
      } | null> | null;
    };
  } | null;
};
export type useLabelsSelectPropsAddLabelsMutation = {
  response: useLabelsSelectPropsAddLabelsMutation$data;
  variables: useLabelsSelectPropsAddLabelsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "labels"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v2 = [
  {
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "labels",
            "variableName": "labels"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AddLabelsPayload",
    "kind": "LinkedField",
    "name": "addLabels",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "count"
          },
          {
            "concreteType": "Label",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "prefix"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "label"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useLabelsSelectPropsAddLabelsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useLabelsSelectPropsAddLabelsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a2d3f14c75bff45a93389f308989352d",
    "id": "30f67e67f8759c6613467d94fc91512ebded25adce73f03c80e1e6fb4fc5a288",
    "metadata": {},
    "name": "useLabelsSelectPropsAddLabelsMutation",
    "operationKind": "mutation",
    "text": "mutation useLabelsSelectPropsAddLabelsMutation($contentId:ID!,$labels:[LabelInput!]!){addLabels(input:{contentId:$contentId,labels:$labels}){__typename,labels{__typename,count,nodes{__typename,id,prefix,name,label}}}}"
  }
};
})();

(node as any).hash = "9e62a6e0f0854070c5914a70ce929b1c";

export default node;
